import { decode } from 'jsonwebtoken';
import { Cookies } from 'react-cookie';

import {
  JWT,
  REFRESH_TOKEN,
  DEMO_STUDENT_JWT,
  DEMO_STUDENT_REFRESH_TOKEN,
  SCHOOLINKS_DOMAIN,
} from 'constants/system';
import { updateSessionStorage } from 'hooks/useRedirect/utils';
import { ROOT } from 'routes/constants';

const cookie = new Cookies();

const isSchooLinksDomain = window?.location?.href
  ? window?.location?.href.indexOf(`${SCHOOLINKS_DOMAIN}/`) !== -1
  : false;

const cookieDomain = isSchooLinksDomain
  ? `.${SCHOOLINKS_DOMAIN}`
  : window.location.hostname;

const setJwtRedirect = () => {
  // Manually update redirect value in sessionStorage
  // Immediately redirect user to '/' after logging in to fix sso redirect issues
  updateSessionStorage({
    to: ROOT,
    reason:
      'setJWT called - user is logging in and needs to be immediately redirected to /',
    component: 'utils/cookies.js',
    pathname: window.location.pathname,
  });
  window.location.href = ROOT;
};

export const getCookie = name => cookie.get(name);

export const getCookiesThatStartWith = name =>
  Object.keys(cookie.getAll()).filter(key => key.startsWith(name));

export const setCookie = ({ name, value, options }) => {
  cookie.set(name, value, options);
};

export const eraseCookie = ({ name, options = {} }) => {
  cookie.remove(name, options);
};

export const updateCookie = ({ key, value, expires }) => {
  setCookie({
    name: key,
    value,
    options: {
      expires,
      path: '/',
      domain: cookieDomain,
    },
  });
};

export const setJWT = ({ isDemoJWT = false, value, redirect = true }) => {
  const decodedJWT = decode(value);
  setCookie({
    name: isDemoJWT ? DEMO_STUDENT_JWT : JWT,
    value,
    options: {
      expires: new Date(decodedJWT.exp * 1000),
      path: '/',
      domain: cookieDomain,
    },
  });
  if (redirect) {
    setJwtRedirect();
  } else {
    // Remove jwt query params from url without refreshing page
    const url = new URL(window.location.href);
    url.searchParams.delete(JWT);
    url.searchParams.delete(REFRESH_TOKEN);
    window.history.replaceState({}, document.title, url.toString());
  }
};

export const setJWTRefresh = ({ isDemoJWT = false, value }) => {
  const decodedJWTRefresh = decode(value);

  setCookie({
    name: isDemoJWT ? DEMO_STUDENT_REFRESH_TOKEN : REFRESH_TOKEN,
    value,
    options: {
      expires: new Date(decodedJWTRefresh.exp * 1000),
      path: '/',
      domain: cookieDomain,
    },
  });
};
